import { UISettingsContainer } from '@/modules/Settings';

export const UISettings = (): JSX.Element => <UISettingsContainer />;

export default UISettings;
